export const mockProjects = [
  {
    id: 'proj-001',
    title: 'Regional Industrial Clustering Strategy — Bursa–Eskişehir–Bilecik',
    client: 'BEBKA (Bursa Eskişehir Bilecik Development Agency)',
    status: 'completed' as const,
    category: 'policy' as const,
    startDate: '2018-03-01',
    endDate: '2019-02-28',
    description:
      'Designed a place-based industrial clustering strategy for the BEB region, identifying priority sectors for cluster formation, mapping value chain linkages and developing a stakeholder engagement framework aligned with EU Smart Specialisation methodology.',
    consultantIds: ['admin-root'],
    budget: 145000,
    createdAt: '2018-02-15',
  },
  {
    id: 'proj-002',
    title: 'Apricot Value Chain Competitiveness Analysis — Malatya',
    client: 'Malatya Kayısıcılar Birliği / OKA',
    status: 'completed' as const,
    category: 'policy' as const,
    startDate: '2020-04-01',
    endDate: '2020-10-30',
    description:
      'Conducted an end-to-end value chain competitiveness analysis for the Malatya apricot sector. Identified structural bottlenecks in processing and packaging, proposed upgrading strategies for value-added export, and provided recommendations for GI brand positioning in European markets.',
    consultantIds: ['admin-root'],
    budget: 68000,
    createdAt: '2020-03-20',
  },
  {
    id: 'proj-003',
    title: 'Earthquake Risk & Business Continuity Assessment — Industrial Facility',
    client: 'TÜPRAŞ Marmara Refinery',
    status: 'completed' as const,
    category: 'engineering' as const,
    startDate: '2021-06-01',
    endDate: '2022-03-15',
    description:
      'Three-layer risk assessment covering structural vulnerability (TBDY-2018 and Eurocode 8), process equipment seismic performance, and business continuity exposure. Delivered prioritised action catalogue for structural retrofitting, equipment upgrades and operational resilience planning.',
    consultantIds: ['admin-root', 'cons-001'],
    budget: 112000,
    createdAt: '2021-05-20',
  },
  {
    id: 'proj-004',
    title: 'Investment Climate & Market Entry Strategy — Turkish Agri-Food Sector',
    client: 'IFC / International Finance Corporation',
    status: 'completed' as const,
    category: 'management' as const,
    startDate: '2019-09-01',
    endDate: '2020-03-31',
    description:
      'Advisory engagement supporting IFC portfolio assessment of agri-food investment opportunities in Turkey. Deliverables included competitive landscape mapping, investment climate benchmarking, and entry strategy options for mid-market agri-processing targets.',
    consultantIds: ['admin-root'],
    budget: 94000,
    createdAt: '2019-08-10',
  },
  {
    id: 'proj-005',
    title: 'EU Cohesion Policy Alignment & Regional Action Plan',
    client: 'İzmir Metropolitan Municipality',
    status: 'completed' as const,
    category: 'policy' as const,
    startDate: '2022-01-15',
    endDate: '2022-12-30',
    description:
      'Aligned İzmir metropolitan development plans with EU cohesion policy frameworks, incorporating Smart Specialisation (S3) approaches, output-based performance indicators and structured stakeholder engagement. Prepared a 5-year regional action plan with priority investment axes.',
    consultantIds: ['admin-root', 'cons-002'],
    budget: 88000,
    createdAt: '2022-01-01',
  },
  {
    id: 'proj-006',
    title: 'Feasibility Study & CAPEX Estimation — Organised Industrial Zone',
    client: 'Ankara Development Agency',
    status: 'completed' as const,
    category: 'engineering' as const,
    startDate: '2016-02-01',
    endDate: '2016-08-30',
    description:
      'Full feasibility study and capital expenditure estimation for a new organised industrial zone in Central Anatolia. Scope included demand analysis, infrastructure costing via reference-class forecasting, risk-adjusted scenario modelling, and procurement strategy.',
    consultantIds: ['admin-root', 'cons-001'],
    budget: 75000,
    createdAt: '2016-01-20',
  },
  {
    id: 'proj-007',
    title: 'Competitive Intelligence System Design',
    client: 'Türk Alman Ticaret ve Sanayi Odası',
    status: 'completed' as const,
    category: 'management' as const,
    startDate: '2023-03-01',
    endDate: '2023-08-31',
    description:
      'Designed a structured competitive intelligence monitoring system for the bilateral chamber, covering Turkish industry sectors of German FDI interest. Delivered sector briefs, competitor profiling templates and a quarterly intelligence digest framework.',
    consultantIds: ['admin-root'],
    budget: 42000,
    createdAt: '2023-02-15',
  },
  {
    id: 'proj-008',
    title: 'Organisational Transformation Roadmap — Multi-Sector Holding',
    client: 'Confidential — Holding Group',
    status: 'completed' as const,
    category: 'management' as const,
    startDate: '2017-05-01',
    endDate: '2017-12-31',
    description:
      'Facilitated a full organisational transformation program for a diversified holding across energy, food and real estate subsidiaries. Covered governance redesign, performance management systems, leadership alignment workshops, and a 90-day quick-win programme.',
    consultantIds: ['admin-root', 'cons-003'],
    budget: 135000,
    createdAt: '2017-04-10',
  },
  {
    id: 'proj-009',
    title: 'Wind Energy Feasibility Study — Aegean Region',
    client: 'Green Anatolia Energy',
    status: 'active' as const,
    category: 'engineering' as const,
    startDate: '2024-06-01',
    endDate: '2025-02-28',
    description:
      'Feasibility study and CAPEX/OPEX estimation for a 50 MW wind farm in the Aegean region, including site suitability, grid connection cost, permitting risk assessment and bankable financial modelling.',
    consultantIds: ['cons-001', 'admin-root'],
    budget: 95000,
    createdAt: '2024-05-10',
  },
  {
    id: 'proj-010',
    title: 'Strategic Positioning — MENA Market Entry',
    client: 'TechStart Ventures (UAE)',
    status: 'active' as const,
    category: 'management' as const,
    startDate: '2024-03-01',
    endDate: '2024-09-30',
    description:
      'Comprehensive market analysis and competitive positioning strategy for a technology startup entering the MENA market. Deliverables: competitor intelligence dossiers, positioning whitepaper, partner ecosystem map, and go-to-market sequencing.',
    consultantIds: ['admin-root', 'cons-003'],
    budget: 55000,
    createdAt: '2024-02-15',
  },
];
